/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './JointlyOwnedVehicleInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { formatMasterNumber } from '../../../../shared/helpers/formatMasterNumber'
const JointMasterNumber = ({ t, i18n, validateJointMasterNumber, jointMasterNumberValid, jointMasterNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const jointMasterNumber = useSelector((state) => state.app.jointlyOwnedVehicleInformation.jointMasterNumber)

  const handleMasterNumber = (e) => {
    try {
      let masterNumberElem = e.currentTarget.value
      dispatch(changeObjectPropertyAction('jointlyOwnedVehicleInformation', 'jointMasterNumber', masterNumberElem))
      validateJointMasterNumber(masterNumberElem)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurMasterNumber = (e) => {
    try {
      SetIsFocussed(false)
      if (RegExp(/^[a-zA-Z0-9 ]{10,14}$/i).test(e.currentTarget.value) && RegExp(/^[a-zA-Z]*$/i).test(e.currentTarget.value[0])) {
        const masterNum = formatMasterNumber(e.currentTarget.value)
        dispatch(changeObjectPropertyAction('jointlyOwnedVehicleInformation', 'jointMasterNumber', masterNum))
        validateJointMasterNumber(masterNum)
      } else {
        dispatch(changeObjectPropertyAction('jointlyOwnedVehicleInformation', 'jointMasterNumber', e.currentTarget.value.trim().toUpperCase()))
        validateJointMasterNumber(e.currentTarget.value.trim())
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const helpURL = i18n.language === "en"
    ? "https://support.novascotia.ca/services/address-changes#finding-master-number-permit"
    : "https://support.novascotia.ca/services/address-changes-fr#finding-master-number-permit"

  return (
    <div className={[
      jointMasterNumberValid === true
        ? jointMasterNumberValid === ''
          ? ''
          : 'form-group has-success'
        : jointMasterNumberValid === false
          ? 'form-group has-error'
          : '',
      styles['fields_margin'],
    ].join(' ')}>
      <div className="ns-label-wrapper">
        <label className="ns-label" htmlFor="JointMasterNumber">
          <strong>{t('jointly_owned_vehicle_info.joint_master_number')}</strong>
        </label>
      </div>
      <div id="joint_master-number-hint" className="ns-hint">
        {t('jointly_owned_vehicle_info.this_is_not')}<strong>{t('jointly_owned_vehicle_info.not')}</strong>{t('jointly_owned_vehicle_info.on_your')}<br />
        {t('jointly_owned_vehicle_info.you_can')}<a
          target="_blank"
          rel="noopener noreferrer"
          href={helpURL}
        >
          {' '}
          {t('jointly_owned_vehicle_info.find_this_master')}
          <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
        </a>.
      </div>
      {(jointMasterNumberValid === true || jointMasterNumberValid === '') ? (
        null
      ) :
        (
          <span id="joint_master-number-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
            <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
            <span className="ns-visually-hidden">{t('shared.error')}</span> {t(jointMasterNumberError)}
          </span>
        )}
      <div style={{ display: "flex", overflow: "auto" }}>
        <input className={[
          'fw-20',
          (jointMasterNumberValid === true) ? 'ns-input--success' : '',
          (jointMasterNumberValid !== true && jointMasterNumberValid !== '') ? 'ns-input--error' : ''].join(' ')}
          id="JointMasterNumber" name="JointMasterNumber" type="text"
          style={{ flexGrow: 1, minWidth: "3em" }}
          aria-describedby="joint-master-number"
          onChange={handleMasterNumber}
          onBlur={onBlurMasterNumber}
          onFocus={() => SetIsFocussed(true)}
          value={jointMasterNumber}
          autoComplete="off"
          maxLength="14" />
        {(jointMasterNumberValid === true) && (
          <div style={{ display: "inline-flex", marginLeft: "1rem", alignItems: "center" }}  ><i className="fa fa-check-circle fa-lg" aria-hidden="true"></i></div>
        )}
      </div>
    </div>
  )
}

export default withTranslation('common')(JointMasterNumber)